/*
 * Tree Selection Selectors
 *
 * Pure read-only helpers over treeSelectionState (no mutation). Kept separate
 * from the canonical route render selectors.
 */

export const isRouteSelected = (state, routeId) =>
  state.ui.selectedRouteIds.includes(routeId)

export const isVesselExpanded = (state, vesselId) =>
  state.ui.expandedVesselIds.includes(vesselId)

export const isVoyageExpanded = (state, voyageId) =>
  state.ui.expandedVoyageIds.includes(voyageId)
